<template>
    <div :class="['cgz', { 'm_cgz': !isPC }]">
        <img class="title" src="https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/cgz_title.png" alt="">
        <div :class="['bigMapBox', { 'isM': !isPC }]">
            <div class="bg" @mousedown="move" @touchstart="moveM" ref="carouselContent" id="bg">
                <div class="seamless-scroll-wrapper">
                    <div class="dian" v-for="(dian, index) in dataList" :key="index">
                        <imgCard :divisor="2.5" :item="dian" @showDetail="showDetail"></imgCard>
                    </div>
                </div>
            </div>
        </div>

        <i class="btu el-icon-d-arrow-left" @click="moveClick('right')"></i>
        <i class="btu el-icon-d-arrow-right" @click="moveClick('left')"></i>
        <div class="dialog-mask" v-if="showDetailPage">
            <img :class="['closeMask', { 'isM': !isPC }]" src="../../assets/close_b.svg" alt=""
                @click.stop="closeDetail">
            <div class="dialog-mask-content">
                <detailPage :id="activeBoothNo" @closeDetail="closeDetail"></detailPage>
            </div>
        </div>

        <div :class="['search-wapper', { 'mShow': showSearch }]" v-if="isPC">
            <span class="search-item">
                <input type="text" v-model.trim="searchWord" />
                <span class="search-icon" @click="doSerach"></span>
            </span>
            <div class="content-area" v-if="showSearch">
                <div class="list-wrapper">
                    <searchPageCard v-for="item of searchDataList" :key="item.boothNo" widthD="240px" :item="item"
                        :lang="currentLang" @showDetail="showDetail">
                    </searchPageCard>
                </div>
            </div>

            <Pagination v-if="isPC" :total='total' width="100%" :currentPage="currentPage" :pageSize="pageSize"
                @pageChange="changePage" />
        </div>
    </div>
</template>

<script>
import imgCard from './imgCard'
import detailPage from './detailPage.vue'
import searchPageCard from '../youth_science/card.vue'
import Pagination from '@/common/Pagination'
export default {
    components: { imgCard, searchPageCard, Pagination, detailPage },
    name: 'cgz',
    data() {
        return {
            dataList: [
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A01_524.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A02_484.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A03_458.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A04_503.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A05_490.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A06_451.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A08_367.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A10_368.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A11_489.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A12_448.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A13_502.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A14_452.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A15_518.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A16_736.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A17_368.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A18_371.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A19_468.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A20_450.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A07_407.png',//澳门
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A09_485.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A21_466.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A22_493.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A23_367.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A24_472.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A25_457.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A26_367.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A27_483.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A28_476.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A29_365.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A30_440.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A31_501.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A32_379.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A33_457.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A34_440.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A35_443.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A36_446.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A37_368.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A38_454.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A39_485.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A40_452.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A41_484.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A42_452.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A43_483.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A44_503.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A45_411.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A46_460.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A47_368.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A48_488.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A49_485.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A50_457.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A51_380.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A52_367.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A53_370.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A54_484.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A55_453.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A56_483.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A57_449.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A58_467.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A59_490.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A60_477.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A61_502.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A62_411.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A63_490.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A64_359.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A65_437.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A66_486.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A67_575.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A68_551.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A69_555.png',
                'https://cdnzyzs.secsa.cn/qingbohuizs/2024/cgz_image/A70_383.png'

                // require('../../assets/cgz_image/A01_524.png'),
                // require('../../assets/cgz_image/A02_484.png'),
                // require('../../assets/cgz_image/A03_458.png'),
                // require('../../assets/cgz_image/A04_503.png'),
                // require('../../assets/cgz_image/A05_490.png'),
                // require('../../assets/cgz_image/A06_451.png'),
                // require('../../assets/cgz_image/A07_407.png'),
                // require('../../assets/cgz_image/A08_367.png'),
                // require('../../assets/cgz_image/A09_485.png'),
                // require('../../assets/cgz_image/A10_368.png'),
                // require('../../assets/cgz_image/A11_489.png'),
                // require('../../assets/cgz_image/A12_448.png'),
                // require('../../assets/cgz_image/A13_502.png'),
                // require('../../assets/cgz_image/A14_452.png'),
                // require('../../assets/cgz_image/A15_518.png'),
                // require('../../assets/cgz_image/A16_736.png'),
                // require('../../assets/cgz_image/A17_368.png'),
                // require('../../assets/cgz_image/A18_371.png'),
                // require('../../assets/cgz_image/A19_468.png'),
                // require('../../assets/cgz_image/A20_450.png'),
                // require('../../assets/cgz_image/A21_466.png'),
                // require('../../assets/cgz_image/A22_493.png'),
                // require('../../assets/cgz_image/A23_367.png'),
                // require('../../assets/cgz_image/A24_472.png'),
                // require('../../assets/cgz_image/A25_457.png'),
                // require('../../assets/cgz_image/A26_367.png'),
                // require('../../assets/cgz_image/A27_483.png'),
                // require('../../assets/cgz_image/A28_476.png'),
                // require('../../assets/cgz_image/A29_365.png'),
                // require('../../assets/cgz_image/A30_440.png'),
                // require('../../assets/cgz_image/A31_501.png'),
                // require('../../assets/cgz_image/A32_379.png'),
                // require('../../assets/cgz_image/A33_457.png'),
                // require('../../assets/cgz_image/A34_440.png'),
                // require('../../assets/cgz_image/A35_443.png'),
                // require('../../assets/cgz_image/A36_446.png'),
                // require('../../assets/cgz_image/A37_368.png'),
                // require('../../assets/cgz_image/A38_454.png'),
                // require('../../assets/cgz_image/A39_485.png'),
                // require('../../assets/cgz_image/A40_452.png'),
                // require('../../assets/cgz_image/A41_484.png'),
                // require('../../assets/cgz_image/A42_452.png'),
                // require('../../assets/cgz_image/A43_483.png'),
                // require('../../assets/cgz_image/A44_503.png'),
                // require('../../assets/cgz_image/A45_411.png'),
                // require('../../assets/cgz_image/A46_460.png'),
                // require('../../assets/cgz_image/A47_368.png'),
                // require('../../assets/cgz_image/A48_488.png'),
                // require('../../assets/cgz_image/A49_485.png'),
                // require('../../assets/cgz_image/A50_457.png'),
                // require('../../assets/cgz_image/A51_380.png'),
                // require('../../assets/cgz_image/A52_367.png'),
                // require('../../assets/cgz_image/A53_370.png'),
                // require('../../assets/cgz_image/A54_484.png'),
                // require('../../assets/cgz_image/A55_453.png'),
                // require('../../assets/cgz_image/A56_483.png'),
                // require('../../assets/cgz_image/A57_449.png'),
                // require('../../assets/cgz_image/A58_467.png'),
                // require('../../assets/cgz_image/A59_490.png'),
                // require('../../assets/cgz_image/A60_477.png'),
                // require('../../assets/cgz_image/A61_502.png'),
                // require('../../assets/cgz_image/A62_411.png'),
                // require('../../assets/cgz_image/A63_490.png'),
                // require('../../assets/cgz_image/A64_359.png'),
                // require('../../assets/cgz_image/A65_437.png'),
                // require('../../assets/cgz_image/A66_486.png'),
                // require('../../assets/cgz_image/A67_575.png'),
                // require('../../assets/cgz_image/A68_551.png'),
                // require('../../assets/cgz_image/A69_555.png'),
                // require('../../assets/cgz_image/A70_383.png')
            ],
            showDetailPage: false,
            activeBoothNo: '',
            searchWord: '',
            totalDataList: [],
            searchDataList: [],
            total: 0,
            currentPage: 1,
            pageSize: 9,
            showSearch: false
        };
    },
    methods: {
        changePage(page) {
            this.currentPage = page
            this.searchDataList = this.totalDataList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
            this.showSearch = true;
        },
        getLogo(item, useFor) {
            let imgs = item.pictures || []
            let log = ''
            for (let item of imgs) {
                if (item.useFor && item.useFor === useFor) {
                    log = item.filePath
                    break
                }
            }
            return log
        },
        doSerach() {
            let data = (this.$allData[this.currentLang] || []).filter(item => {
                return item.boothNo && item.boothNo.indexOf('A') === 0
            })
            let query = this.searchWord;
            if (!query) {
                this.totalDataList = data.map(item => {
                    item._logo = this.getLogo(item, 'cover')
                    return item
                })
                this.total = this.totalDataList.length;
            } else {
                let showDataList = []
                for (let item of data) {
                    item._logo = this.getLogo(item, 'cover')
                    if ((item.worksName && item.worksName.indexOf(query) >= 0) || (item.companyName && item.companyName.indexOf(query) >= 0)) {
                        // 作品名，单位名
                        showDataList.push(item)
                    } else if ((item.creatorName && item.creatorName.indexOf(query) >= 0) || (item.school && item.school.indexOf(query) >= 0)) {
                        // 作者名 学校
                        showDataList.push(item)
                    } else if ((item.countryRegion && item.countryRegion.indexOf(query) >= 0) || (item.provinceCity && item.provinceCity.indexOf(query) >= 0)) {
                        // 国家，地区
                        showDataList.push(item)
                    } else if (item.boothNo && item.boothNo.indexOf(query) >= 0) {
                        // 展位号
                        showDataList.push(item)
                    } else if ((item.workIntroductin && item.workIntroductin.indexOf(query) >= 0) || (item.companyDesc && item.companyDesc >= 0)) {
                        // 作品 企业简介
                        showDataList.push(item)
                    }
                }
                this.totalDataList = showDataList;
                this.total = showDataList.length;
            }
            this.changePage(1)
        },
        moveClick(side) {
            // 获取元素
            var img = document.querySelector(".bg");
            img.style.transition = 'all .5s';
            var x = img.offsetLeft;
            var imgWidth = img.offsetWidth;
            var winWidth = window.innerWidth || window.visualViewport.width;
            var ram = imgWidth - winWidth;
            let left = x - winWidth + 300;
            if (side == 'right') {
                left = x + winWidth - 300;
            }
            left = left > 0 ? 0 : Math.abs(left) < ram ? left : -ram;
            img.style.left = left + "px";
            setTimeout(() => {
                img.style.transition = '';
            }, 500)
        },
        closeDetail() {
            this.showDetailPage = false;
            this.$nextTick(() => {
                this.activeBoothNo = '';
            })
        },
        showDetail(item) {
            let boothNo = ''
            if (typeof item == 'string') {
                boothNo = item.split('/')[item.split('/').length - 1].split('_')[0];
            } else {
                boothNo = item.boothNo;
            }
            this.activeBoothNo = boothNo;
            this.showDetailPage = true;
        },
        // 拖动图片
        move(e) {
            e.preventDefault();
            // 获取元素
            var left = document.querySelector(".bigMapBox");
            var img = document.querySelector(".bg");
            var x = e.pageX - img.offsetLeft;
            // var y = e.pageY - img.offsetTop;
            var imgWidth = img.offsetWidth;
            var winWidth = window.innerWidth || window.visualViewport.width;
            var ram = imgWidth - winWidth;
            // 添加鼠标移动事件
            left.addEventListener("mousemove", move);

            function move(e) {
                let left = e.pageX - x;
                // let top = e.pageY - y;
                left = left > 0 ? 0 : Math.abs(left) < ram ? left : -ram;
                // top = top > 0 ? 0 : top;
                // left = left > 0 ? 0 : left;
                // top = top > 0 ? 0 : top;

                img.style.left = left + "px";
                // img.style.top = top + "px";
            }
            // 添加鼠标抬起事件，鼠标抬起，将事件移除
            img.addEventListener("mouseup", function () {
                left.removeEventListener("mousemove", move);
            });
            // 鼠标离开父级元素，把事件移除
            left.addEventListener("mouseout", function () {
                left.removeEventListener("mousemove", move);
            });
        },
        // 拖动图片
        moveM(e) {
            e.preventDefault();
            // 获取元素
            var left = document.querySelector(".bigMapBox");
            var img = document.querySelector(".bg");
            var x = e.pageX - img.offsetLeft;
            var y = e.pageY - img.offsetTop;
            // 添加鼠标移动事件
            left.addEventListener("touchmove", move);
            function move(e) {
                img.style.left = e.pageX - x + "px";
                img.style.top = e.pageY - y + "px";
            }
            // 添加鼠标抬起事件，鼠标抬起，将事件移除
            img.addEventListener("touchend", function () {
                left.removeEventListener("touchmove", move);
            });
            // 鼠标离开父级元素，把事件移除
            left.addEventListener("touchend", function () {
                left.removeEventListener("touchmove", move);
            });
        },
    }
};
</script>

<style scoped>
.cgz {
    position: relative;
    padding-top: calc((100vh - 512px - 120px)/2);
    box-sizing: border-box;
    height: 100%;
    overflow-y: auto;
    background-color: #c4c8d3;
}

.title {
    display: block;
    width: 80%;
    margin: 0 auto;
}

.bigMapBox {
    width: 100%;
    height: 512px;
    margin: 0 auto;
    margin-top: 20px;
    position: relative;
    overflow: hidden;
    text-align: center;
    border: none
}

.bg {
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    cursor: grab;
    border: none;
    font-size: 0;
    width: 3960px;
    text-align: left;
    /* transition:'all .3s' */
    padding: 30px;
    border-radius: 1000px;
    /* 圆角大小 */
    background-image: linear-gradient(to right, #4c9cb3, #4676c6, #8595b9, #84a8dd, #bdd2ef);
    /* 渐变色 */
    /* 透明边框，避免遮挡背景 */
    overflow: hidden;
    z-index: 1;
}

.seamless-scroll-wrapper {
    position: relative;
    padding: 20px 160px 10px 0;
    height: 100%;
    border-radius: 1000px;
    background-image: linear-gradient(to right, #cdd0de, #ceceda, #ced2dd);
    z-index: 0;
    min-height: 430px;
}

.seamless-scroll-wrapper img {
    margin-right: 20px;
    margin-bottom: 2px;
    vertical-align: middle;
    cursor: pointer;
}

.dian {
    display: inline-block;
}

.dian:nth-child(1) {
    margin-left: 140px;
}

.dian:nth-child(18) {
    margin-left: 60px;
}

.dian:nth-child(37) {
    margin-left: 40px;
}

.dian:nth-child(55) {
    margin-left: 170px;
}

.bigMapBox.isM {
    width: 4000px;
    height: calc(100vh - 90px);
}

.btu {
    position: fixed;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 1000;
    font-size: 6rem;
    color: #333;
    opacity: 0.5;
    cursor: pointer;
    animation: flash 3s infinite ease-in-out;
}

.btu:hover {
    opacity: 1;
    animation: none;
}


@keyframes flash {

    0%,
    100% {
        opacity: 1;
    }

    75% {
        opacity: 1;
    }

    25% {
        opacity: 1;
    }

    50% {
        opacity: 0.3;
    }
}

.el-icon-d-arrow-left {
    left: 2rem;
}

.el-icon-d-arrow-right {
    right: 2rem;
}

.search-wapper {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 22rem;
    height: 52px;
    box-sizing: border-box;
    padding: 2rem 0 0 2rem;
    background-color: transparent;
    overflow: hidden;
}

.search-wapper.mShow {
    transition: all 0.5s ease-in-out;
}

.search-item input {
    width: 16rem;
    height: 32px;
    line-height: 32px;
    border: 1px solid #ffffff;
    outline: none;
    background: transparent;
    color: #ffffff;
    font-size: 14px;
    border-radius: 16px;
    padding-left: 1rem;
    padding-right: 1rem;
}

.search-item input:focus {
    outline: none;
}


.search-wapper.mShow:hover {
    top: 0;
    left: 0;
    padding: 2rem;
    width: 860px;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 10px #ccc;
}

/* .search-wapper.mShow:hover .search-item input {
    width: 70%;
} */

.search-icon {
    display: inline-block;
    width: 22px;
    height: 24px;
    margin-left: 10px;
    color: #ffffff;
    /* background-image: url("data:image/svg+xml,<svg width='1em' height='1em' viewBox='0 0 16 16' class='bi bi-search' fill='%23fff' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' d='M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z'/><path fill-rule='evenodd' d='M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z'/></svg>"); */
    background-image: url("../../assets/web/search_icon.png");
    background-size: 100% 100%;
    vertical-align: middle;
    cursor: pointer;
}

.mShow .content-area {
    padding-top: 20px;
    margin-bottom: 10px;
    height: calc(100% - 34px - 56px);
    overflow-y: auto;
}


.btu.isM {
    font-size: 2rem
}

.dialog-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99999;
}

.closeMask {
    position: fixed;
    top: -20px;
    right: 0;
    z-index: 1000;
    font-size: 20px;
    opacity: 0.8;
    cursor: pointer;
    transform: all 0.5s ease-in-out;
}

.closeMask:hover {
    opacity: 1;
}

.closeMask.isM {
    width: 10rem;
    top: 0;
}


.dialog-mask-content {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #fff;
    overflow-y: auto;
}

.m_cgz {
    padding-top: 50px;
}

.m_cgz .title {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 1000;
}
</style>